import DataSourceHelper from '../../../../helper/DataSourceHelper';
import DependencyFlowHelper from '../../../../helper/DependencyFlowHelper';
import { useDSCDataSourceRecordStore, useDSCGlobalStateStore } from '../../context/selectors';

function usePreviewDataSourceIds() {
  const dsDependencyFlow = useDSCGlobalStateStore().hooks.dataSource.useDependencyFlow();
  const getDataSourceRecordsState = useDSCDataSourceRecordStore().getState;
  const previewTriggeredDataSources = useDSCGlobalStateStore().hooks.usePreviewTriggeredDataSources();

  const previewDataSourceIds = Object.entries(previewTriggeredDataSources ?? {}).reduce<string[]>(
    (acc, [id, value]) => {
      if (value) acc.push(id);
      return acc;
    },
    [],
  );

  const freePreviewDataSourceIds = previewDataSourceIds.filter((id) => {
    const intraDependencies = DataSourceHelper.getPreviewDataSourceTentativeDependencies(
      id,
      getDataSourceRecordsState,
    );
    return DependencyFlowHelper.areAllDependenciesFinished({
      dependencies: intraDependencies[id],
      dependencyFlowInstance: dsDependencyFlow,
    });
  });

  return {
    ids: freePreviewDataSourceIds,
  };
}

export default usePreviewDataSourceIds;
